import React from "react";
import { useNavigate } from "react-router-dom";
import {BulletIcon} from "../../assets";

const ProgramCard = ({
  title,
  score,
  oldPrice,
  price,
  description,
  features,
  ctaLabel,
  theme = "intensive",
  badgeText,
}) => {
  const isPrivate = theme === "private";
  const navigate = useNavigate();
  const [titleMain, ...titleRest] = title.split(" ");
  const titleItalic = titleRest.join(" ");

  const handleCtaClick = () => {
    navigate(isPrivate ? "/produk/KelasPrivate" : "/produk/KelasIntensif");
  };

  return (
    <article className="st-program-card relative flex h-full flex-col p-5 sm:p-6">
      {badgeText ? (
        <p className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-[#3A1D1D] px-4 py-1 text-[11px] font-bold tracking-[0.08em] text-white">
          {badgeText}
        </p>
      ) : null}

      <h3 className="st-font-body mt-2 text-[34px] font-bold leading-none text-[#3A1D1D]">
        {titleMain} <span className="font-normal italic">{titleItalic}</span>
      </h3>

      <div className="mt-5 flex items-start gap-4 border-b border-[#BDB7B4] pb-5">
        <div
          className={`relative flex h-[84px] w-[74px] shrink-0 flex-col items-center rounded-[12px] border-2 border-[var(--st-color-text)] px-2 py-2 ${
            isPrivate ? "bg-[#CF230D] text-white" : "bg-[#D7D3D1]"
          }`}
        >
          <span
            className={`st-font-body px-2 py-[11px] text-[40px] font-bold leading-none ${
              isPrivate ? "text-white" : "text-[var(--st-color-text)]"
            }`}
          >
            {score}
          </span>
          <span
            className={`absolute -bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full px-2 py-[2px] text-[11px] font-bold ${
              isPrivate ? "bg-[#3A1D1D] text-white" : "bg-[#2A2929] text-white"
            }`}
          >
            TARGET SCORE
          </span>
        </div>

        <div className="st-font-body pt-1 text-left text-[20px] leading-[1.35] text-[#4A4342]">
          {description}
          <p className="mt-1 text-[18px] text-[#8A7C7A] line-through">{oldPrice}</p>
          <p className="text-[32px] font-bold leading-none text-[#302728]">{price}</p>
        </div>
      </div>

      <ul className="mt-5 space-y-3">
        {features.map((feature) => (
          <li key={feature} className="flex items-center gap-3">
            <img src={BulletIcon} alt="bullet" className="h-5 w-5 shrink-0" loading="lazy" />
            <p className="st-font-body text-[16px] leading-[1.3] text-[#4A4342]">{feature}</p>
          </li>
        ))}
      </ul>

      <button
        type="button"
        onClick={handleCtaClick}
        className={`st-focus-ring mt-6 h-12 rounded-[8px] border text-sm font-bold tracking-[0.03em] transition-colors ${
          isPrivate
            ? "border-[#4C1310] bg-[#4C1310] text-white hover:bg-[#3A0F0C]"
            : "border-[#BDB7B4] bg-[#EBE7E6] text-[#6C6665] hover:bg-[#dfd7d6]"
        }`}
      >
        {ctaLabel}
      </button>
    </article>
  );
};

export default ProgramCard;
